/**
 * Function to determine if a value should render or not. This
 * function returns false when value is null, false, NaN, undefined,
 * or an empty string (""). All other values, will return true.
 * @param {*} value Value that needs to be tested
 */
export default (value: any): boolean => Boolean(value) || value === 0;
